import { useContext, React, useState } from 'react';
import { CartContext } from '../context/CartContext';
import { Link } from "react-router-dom";


const CarritoBtn = () => {

    const { cart,precioTotal } = useContext(CartContext);

    const goToCart = (e) => {

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    return (
        <>
            {
                cart.length >= 1 ?

                        <Link className='link-carrito' to="/carrito">
                            <button className='carrito-btn' onClick={goToCart}>Ver mi pedido ${precioTotal}</button>
                        </Link>
                    :
                    null
            }
        </>
    )
}

export default CarritoBtn